<template>
  <div class="reference-block scrollbar scrollbar--secondary">
    <!-- Журнал талонов -->
      <div
        id="talon-ticket-log"
        class="reference-block-link"
        v-if="userCan('ticket_system_show')"
      >
        <router-link :to="{ name: 'talon-ticket-log' }" class="links-item">
          <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('talon-ticket-log') }}
            <div v-if="isActiveHotSpot('talon-ticket-log')?.id" class="hotspot"
              @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
                  hoverEvent: $event,
                  tooltipText: currentTooltipForHotSpot('talon-ticket-log'),
                })"
              @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
              Новое
            </div>
          </div>
        </router-link>
      </div>

      <!-- Журнал взвешиваний -->
      <div
        id="talon-weighing-log"
        class="reference-block-link"
        v-if="userCan('ticket_system_show')"
      >
        <router-link :to="{ name: 'talon-weighing-log' }" class="links-item">
          <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('talon-weighing-log') }}
            <div v-if="isActiveHotSpot('talon-weighing-log')?.id" class="hotspot"
              @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
                  hoverEvent: $event,
                  tooltipText: currentTooltipForHotSpot('talon-weighing-log'),
                })"
              @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
              Новое
            </div>
          </div>
        </router-link>
      </div>

      <!-- Отчеты по периодам -->
      <div
        id="talon-period-reports"
        class="reference-block-link"
        v-if="userCan('ticket_system_show')"
      >
        <router-link :to="{ name: 'talon-period-reports' }" class="links-item">
          <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('talon-period-reports') }}
            <div v-if="isActiveHotSpot('talon-period-reports')?.id" class="hotspot"
              @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
                  hoverEvent: $event,
                  tooltipText: currentTooltipForHotSpot('talon-period-reports'),
                })"
              @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
              Новое
            </div>
          </div>
        </router-link>
      </div>

      <!-- Сверка с контрагентами -->
      <div
        id="talon-contractor-reconciliation"
        class="reference-block-link"
        v-if="userCan('ticket_system_show')"
      >
        <router-link :to="{ name: 'talon-contractor-reconciliation' }" class="links-item">
          <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('talon-contractor-reconciliation') }}
            <div v-if="isActiveHotSpot('talon-contractor-reconciliation')?.id" class="hotspot"
              @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
                  hoverEvent: $event,
                  tooltipText: currentTooltipForHotSpot('talon-contractor-reconciliation'),
                })"
              @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
              Новое
            </div>
          </div>
        </router-link>
      </div>

      <!-- Экспорт в 1С -->
      <div
        id="talon-export-1c"
        class="reference-block-link"
        v-if="userCan('ticket_system_show')"
      >
        <router-link :to="{ name: 'talon-export-1c' }" class="links-item">
          <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('talon-export-1c') }}
            <div v-if="isActiveHotSpot('talon-export-1c')?.id" class="hotspot"
              @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
                  hoverEvent: $event,
                  tooltipText: currentTooltipForHotSpot('talon-export-1c'),
                })"
              @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
              Новое
            </div>
          </div>
        </router-link>
      </div>
      
      <div
        id="contract-journal-ecoprom"
        class="reference-block-link"
        v-if="true"
      >
        <router-link :to="{ name: 'contract-journal-ecoprom' }" class="links-item">
          <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('contract-journal-ecoprom') }}
            <div v-if="isActiveHotSpot('contract-journal-ecoprom')?.id" class="hotspot"
              @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
                  hoverEvent: $event,
                  tooltipText: currentTooltipForHotSpot('contract-journal-ecoprom'),
                })"
              @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
              Новое
            </div>
          </div>
        </router-link>
      </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      userCan: "user/userCan",
      getByHotSpotRouteTitleMenu: "hotspots/getByHotSpotRouteTitleMenu",
      allListActiveHotSpots: "hotspots/allListActiveHotSpots",
    }),
  },
  methods: {
    isActiveHotSpot(menu) {
      const rusNameMenu = this.getByHotSpotRouteTitleMenu(menu)
      const result = this.allListActiveHotSpots.find(item => item.menu === rusNameMenu);
      return result;
    },
    currentTooltipForHotSpot(menu) {
      const hotSpot = this.isActiveHotSpot(menu);
      if (Object.entries(hotSpot).length &&  hotSpot.tooltip) {
        return hotSpot.tooltip
      } 
      return ''
    }
  }
};
</script>

<style lang="scss" scoped>
.reference-block {
  padding: 20px 25px;
  z-index: 1;
  display: grid;
  row-gap: 20px;
  position: absolute;
  top: 52px;
  left: 0;
  width: 398px;
  max-height: 566px;
  border-radius: 5px;
  background-color: #1d838d;
  overflow-x: hidden;

  &::after {
    margin-top: 2px;
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 398px;
    height: calc(100% - 2px);
    background: #1d838d;
    box-shadow: 4px 4px 8px 2px rgba(57, 134, 144, 0.5);
    border-radius: 5px;
  }

  &-link {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    height: 100%;

    & a {
      display: inline-block;
      width: 100%;
      height: 100%;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
    }

    &:hover {
      & a {
        color: #44ff8f;
      }
    }
  }
  .link-flex {
    display: flex;
    align-items: center
  }
}
</style>